@if (showIcon) {
    @if (!isLegacy) {
        <cs-cta class="cs-cta" [kind]="kind" [variant]="variant" [size]="size" [cta_text]="cta_text" [casinoDsClass]="casinoDsClass">
            <ng-content slot="start" select="[slot=start]"></ng-content>
            {{ cta_text }}
            <ng-content slot="end" select="[slot=end]"></ng-content>
        </cs-cta>
    }

    @if (isLegacy) {
        <div id="cs-more-info" class="cs-overlay-moreinfo">
            {{ cta_text }}
        </div>
    }
}
